<template lang="pug">
  .wrap
    JobSidebar(:openSidebar="openSidebar" :fixedViewEndDate="true" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': this.headerFixedSp }")
          JobSortArea(@toggleSidebar="toggleSidebar" :totalCount="pagination.totalCount")
        Pagination(
          :pagination="pagination"
          :listUpside="true"
          @selectPage="selectPage"
          :availablePerPage="false")
        .job-list-body
          JobColumnSortModal
          .grouping-job
            GroupingJobTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck",
              @searchOrderBy="searchOrderBy",
            )

            div
              JobTableRows(
                v-for="(v, i) in index",
                :job="v",
                :index="i",
                :key="v.id",
                :checkedIds="pageCheckedIds",
                @display="displayDetailModal",
                @check="toggleCheck",
              )
        Pagination(
          :pagination="pagination"
          @selectPage="selectPage"
          :availablePerPage="false")
      JobShowModal(
        :isOpened="openJobShowModal"
        :jobDetail="jobDetail"
        :updateFavorForIndex="true"
        :haken="this.$route.name === 'SearchGroupingHaken'"
        @hide="hideJobShowModal"
        @update="skipReload")
      JobMenu(@remove="reloadOrSkip" :checkedIds="checkedIdsAll" @setJobModalMode="setJobModalMode")

    SearchConditionModal

    Footer
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { ErrorMessages, perPages } from '../../constants'
  import Footer from '../parts/Footer'
  import JobColumnSortModal from '../parts/JobColumnSortModal'
  import JobShowModal from '../parts/JobShowModal'
  import JobSidebar from '../parts/JobSidebar'
  import JobSortArea from '../parts/JobSortArea'
  import JobTableRows from '../parts/grouping-job/TableRows'
  import GroupingJobTableHeader from '../parts/grouping-job/TableHeader'
  import JobMenu from '../parts/JobMenu'
  import SearchConditionModal from '../parts/SearchConditionModal'
  import Pagination from '../parts/Pagination'

  export default {
    components: {
      JobColumnSortModal,
      Footer,
      JobShowModal,
      JobSidebar,
      JobSortArea,
      JobTableRows,
      GroupingJobTableHeader,
      JobMenu,
      SearchConditionModal,
      Pagination,
    },
    async asyncData ({ store, route: { query, name } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_GROUPING_JOB)
      }
      if (!perPages.map(p => p.code).includes(query.perPage)) {
        throw new Error(ErrorMessages.INVALID_PER_PAGE_SEARCH_GROUPING_JOB)
      }
      await store.dispatch('job/fetchGroupingIndex', { ...query, perPage: 200, haken: (name === 'SearchGroupingHaken') })
      await store.dispatch('client/fetch')
    },
    data () {
      return {
        headerFixedSp: false,
        openJobShowModal: false,
        openSidebar: false,
        openSearchConditionModal: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      ...mapGetters('job', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapState({
        meta: state => state.route.meta,
        pagination: state => state.job.pagination,
        index: state => state.job.index,
        pageCheckedIds: state => state.job.pageCheckedIds,
        checkedIdsAll: state => state.job.checkedIds,
        jobDetail: state => state.job.detail,
      }),
      page () {
        return this.$route.query.page
      },
    },
    watch: {
      $route () {
        this.avoidBlank()
      },
    },
    methods: {
      ...mapMutations('job', ['check', 'uncheck', 'uncheckAll']),
      ...mapActions('job', ['toggleCheck', 'togglePageCheck']),
      displayDetailModal ({ id }) {
        if (id !== this.jobDetail.id) {
          this.$store.dispatch('job/fetchGroupingDetail', { id })
            .then(() => {
              this.openJobShowModal = true
            })
        } else {
          this.openJobShowModal = !this.openJobShowModal
        }
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      async searchOrderBy (order, orderDirection) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order,
            orderDirection,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      hideJobShowModal () {
        this.openJobShowModal = false
      },
      async selectPage (page) {
        this.reload({ page })
      },
      reload ({ page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合は page-- しない。
        // 取得失敗で空配列になった画面で page-- を続けるとエラーループになる。
        if (this.$store.state.job.lastFetchError) return

        // 連射防止: API エラー時に暴走して連続リクエストを飛ばすのを防ぐ
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      async search () {
        this.$store.commit('common/lockGlobal')
        try {
          const query = this.query(new Date().getTime())
          this.$router.push({ name: 'SearchGroupingJob', query })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      setJobModalMode () {
        this.$store.commit('common/setGroupingJobModalMode')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchGroupingJob.vue